import { render } from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=template&id=00aec0e7&scoped=true&ts=true"
import script from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=script&lang=ts"
export * from "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=script&lang=ts"

import "./SelecionarOrigemRecebimentoMercadoriasModal.vue?vue&type=style&index=0&id=00aec0e7&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aec0e7"]])

export default __exports__